import { render } from "./HeroiconsOutlineArrowCircleRight.vue?vue&type=template&id=40e0bbee"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleRight.vue"]])

export default __exports__